/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import type { ResultTaskList } from "client";
import {
  useContext,
  createContext,
  Dispatch,
  SetStateAction,
  PropsWithChildren,
  FC,
  useState,
} from "react";

// context data task Register / edit
export interface TaskData extends ResultTaskList {
  srcJobSetId?: string;
}

interface TaskDataContext {
  taskData: TaskData;
  setTaskData: Dispatch<SetStateAction<TaskData>>;
}

export const initializeTaskData: TaskData = {};
const defaultValue: TaskDataContext = {
  taskData: initializeTaskData,
  setTaskData: (value) => {
    // default no ope.
  },
};

const context = createContext<TaskDataContext>(defaultValue);

interface Props {
  value?: TaskData;
}

export const TaskDataProvider: FC<PropsWithChildren<Props>> = ({
  value = defaultValue.taskData,
  children,
}) => {
  const [taskData, setTaskData] = useState<TaskData>(value);

  return (
    <context.Provider value={{ taskData, setTaskData }}>
      {children}
    </context.Provider>
  );
};

export const useTaskDataContext = () => {
  return useContext(context);
};
